/** Testi del modulo Test finale: stato, tentativo, esito, editor e riepiloghi. */
export const test = {
  titolo: 'Test finale',
  torna: 'Torna al webinar',
  tornaAlPercorso: 'Torna al percorso',
  azioni: {
    fai: 'Fai il test',
    inizia: 'Inizia il test',
    riprendi: 'Riprendi il test',
    vediEsito: 'Vedi l’esito',
    consegna: 'Consegna il test',
    indietro: 'Indietro',
    avanti: 'Avanti',
    riepilogo: 'Riepilogo',
  },
  stato: {
    regole: (domande: number, minuti: number, corrette: number) => `${domande} domande, ${minuti} minuti, un solo tentativo. Lo superi con almeno ${corrette} risposte corrette.`,
    tempoFino: (ora: string) => `Hai tempo fino alle ${ora}.`,
    apreAlleChiusura: 'Il test si apre alla chiusura della diretta.',
    apreVerso: (ora: string) => `Il test si apre alla chiusura della diretta, prevista alle ${ora}.`,
    presenzaInsufficiente: (soglia: number, pct: number) => `Il test si apre quando hai seguito almeno il ${soglia}% della lezione. Ora sei al ${pct}%.`,
    presenzaInsufficienteChiusa: (soglia: number, pct: number) => `Per fare il test serviva almeno il ${soglia}% di presenza: hai seguito il ${pct}%.`,
    presenzaPasso: 'Se pensi che il conteggio sia sbagliato, contatta l’organizzatore: può correggere ingressi e uscite.',
    finestraChiusa: 'Il tempo per fare il test è terminato.',
    finestraChiusaPasso: 'Non è possibile riaprirlo da qui: contatta l’organizzatore.',
    nonPronto: 'Il test non è ancora disponibile.',
    nonProntoPasso: 'L’organizzatore non ha ancora caricato le domande. Riprova tra poco.',
    inCorso: 'Hai un test in corso',
    inCorsoTesto: (risposte: number, totale: number) => `Hai risposto a ${risposte} domande su ${totale}. Il tempo continua a scorrere.`,
    concluso: 'Hai già fatto il test',
    presenzaOk: (pct: number) => `Hai seguito il ${pct}% della lezione: puoi fare il test.`,
  },
  dialogo: {
    titolo: 'Pronto a iniziare?',
    testo: (domande: number, minuti: number, corrette: number) =>
      `Hai un solo tentativo: ${minuti} minuti per ${domande} domande, da quando premi "Inizia". Lo superi con almeno ${corrette} risposte corrette. Le risposte si salvano una per una: se cade la connessione, rientra e continua.`,
    annulla: 'Non ancora',
    conferma: 'Inizia',
  },
  tentativo: {
    tempoRimasto: 'Tempo rimasto',
    domanda: (c: number, t: number) => `Domanda ${c} di ${t}`,
    salvata: 'Risposta salvata',
    inSalvataggio: 'Salvataggio in corso',
    erroreSalvataggio: 'Non riusciamo a salvare la risposta: controlla la connessione e riprova.',
    scaduto: 'Il tempo è terminato: consegniamo le risposte date finora.',
    riepilogoTitolo: 'Riepilogo prima della consegna',
    riepilogoTesto: 'Controlla di aver risposto a tutte le domande. Dopo la consegna non puoi cambiare.',
    senzaRisposta: 'Senza risposta',
    conRisposta: 'Risposta data',
    consegnaTitolo: 'Consegnare il test?',
    consegnaTesto: 'Dopo la consegna non puoi modificare le risposte.',
    consegnaMancanti: (n: number) => `Hai lasciato ${n} ${n === 1 ? 'domanda' : 'domande'} senza risposta: conterà come sbagliata.`,
    consegnaConferma: 'Sì, consegno',
    consegnaAnnulla: 'Torno alle domande',
    erroreConsegna: 'Non riusciamo a consegnare il test. Controlla la connessione e riprova: il tempo è fermo lato server solo alla scadenza.',
    nonTrovato: 'Questo test non esiste o non è tuo.',
  },
  esito: {
    superato: (c: number, t: number) => `Test superato: ${c} risposte corrette su ${t}.`,
    superatoPasso: 'L’attestato arriverà via email e nel tuo percorso.',
    nonSuperato: (c: number, t: number) => `Test non superato: ${c} risposte corrette su ${t}.`,
    nonSuperatoPasso: 'Non è possibile ripetere il test: contatta l’organizzatore.',
    scaduto: (c: number, t: number) => `Tempo scaduto: ${c} risposte corrette su ${t}.`,
    scadutoPasso: (ok: boolean) => (ok ? 'Il test risulta comunque superato: l’attestato arriverà via email e nel tuo percorso.' : 'Non è possibile ripetere il test: contatta l’organizzatore.'),
    minime: (c: number) => `Servivano almeno ${c} risposte corrette.`,
    consegnatoAlle: (ora: string) => `Consegnato alle ${ora}`,
  },
  aula: {
    terminataTest: (ora: string) => `La diretta è terminata: il test è aperto fino alle ${ora}.`,
    terminataTestTesto: 'Lo puoi fare da qui o dal tuo percorso. Un solo tentativo, 10 minuti.',
  },
  admin: {
    scheda: 'Test',
    titolo: 'Test finale',
    sottotitolo: 'Cinque domande, quattro risposte corrette per superarlo. Le domande si bloccano alla chiusura della diretta.',
    modificabile: 'Modificabile fino alla chiusura della diretta',
    bloccato: 'Bloccato: la diretta è stata chiusa',
    nonPronto: 'Il test non è pronto: servono le domande.',
    avvisoNumero: (n: number, attese: number) => `Hai inserito ${n} ${n === 1 ? 'domanda' : 'domande'}: il test previsto ne ha ${attese}.`,
    domanda: (n: number) => `Domanda ${n}`,
    testoDomanda: 'Testo della domanda',
    risposta: (n: number) => `Risposta ${n}`,
    corretta: 'Corretta',
    segnaCorretta: (n: number) => `Segna la risposta ${n} come corretta`,
    aggiungiRisposta: 'Aggiungi una risposta',
    rimuoviRisposta: 'Rimuovi la risposta',
    aggiungiDomanda: 'Aggiungi una domanda',
    rimuoviDomanda: 'Rimuovi la domanda',
    su: 'Sposta su',
    giu: 'Sposta giù',
    corretteMinime: 'Risposte corrette minime per superare il test',
    corretteMinimeAiuto: 'Di norma 4 su 5.',
    salva: 'Salva le domande',
    salvato: 'Domande salvate.',
    nessunaDomanda: 'Nessuna domanda ancora. Aggiungine cinque: testo, da due a sei risposte, una sola corretta.',
    errori: {
      correttaUnica: 'Segna esattamente una risposta corretta.',
      minimeTroppoAlte: 'Le risposte corrette minime non possono superare il numero di domande.',
    },
    riepilogo: {
      titolo: 'Esiti',
      ammessi: 'Ammessi',
      iniziati: 'Iniziati',
      superati: 'Superati',
      nonSuperati: 'Non superati',
      scaduti: 'Scaduti',
      finestra: (ora: string) => `Il test chiude alle ${ora}.`,
      finestraChiusa: (ora: string) => `Il test è chiuso dalle ${ora}.`,
      aggiornamento: 'I numeri si aggiornano ogni 10 secondi.',
    },
    chiudi: 'Chiudi il test in anticipo',
    chiudiTitolo: 'Chiudere il test adesso?',
    chiudiTesto: 'Chi non ha ancora consegnato riceverà l’esito con le risposte date finora. Chi non ha iniziato non potrà più farlo. Non si può annullare.',
    chiudiConferma: 'Sì, chiudi il test',
    chiuso: 'Test chiuso.',
    esiti: {
      colonne: { nome: 'Nome', presenza: 'Presenza', ammesso: 'Ammesso', stato: 'Esito', corrette: 'Corrette', quando: 'Consegnato' },
      cerca: 'Cerca per nome o email',
      filtro: 'Esito',
      tutti: 'Tutti',
      stati: { ammessi: 'Ammessi', non_ammessi: 'Non ammessi', in_corso: 'In corso', superato: 'Superati', non_superato: 'Non superati', scaduto: 'Scaduti', non_iniziato: 'Non iniziati' } as const,
      badge: { in_corso: 'In corso', superato: 'Superato', non_superato: 'Non superato', scaduto: 'Scaduto', non_iniziato: 'Non iniziato', non_ammesso: 'Non ammesso' } as const,
      si: 'Sì',
      no: 'No',
      nessuno: 'Nessun iscritto confermato.',
      nessunRisultato: 'Nessun iscritto corrisponde alla ricerca.',
      didascalia: 'Esiti del test per iscritto',
    },
    vaiAlTest: 'Apri il test',
  },
  relatore: {
    titolo: 'Esiti del test',
    testo: 'Solo i numeri: i nomi li gestisce l’organizzatore.',
  },
};
